/**
 * Created by calhosh on 1/22/2025
 */
import _ from 'lodash';
import initialstate from '../initialstate';
import {GET_AICHATBOT_INTEGRATION_PARAMETERS, SET_AICHATBOT_INTEGRATION_PARAMETERS} from '../../actions/actiontypes';

export default function AIChatBotIntegrationParametersReducer(
	state = initialstate.aiChatBotIntegrationParameters,
	action
) {
	switch (action.type) {
		case SET_AICHATBOT_INTEGRATION_PARAMETERS: {
			let oldState = _.cloneDeep(state);
			if(!_.isEmpty(action.payload)){
				let mergedObject =  _.merge({}, oldState, action.payload);
				return mergedObject;
			}
			return oldState;
		}
		case GET_AICHATBOT_INTEGRATION_PARAMETERS: {
			if (action.response) {
				let oldState = _.cloneDeep(state);
				if (action.response?.entities?.length > 0) {

					let entity = action.response?.entities[0];
					let profileObject = Object.assign({}, ...entity?.engagementProfiles);
					
					let mergedObject = _.merge({}, {engagementDetails: action.response?.engagementDetails}, {gamLayer: entity?.gamLayer}, {engagementProfiles: profileObject});
					mergedObject = _.merge({}, oldState, mergedObject);
					delete mergedObject['entityId'];
					return mergedObject;
				}
			}
			return action.response || state;
		}
		default:
			return state;
	}
}
